/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 * Migrated from: lego/lib/Validation.jsx
 */

class Validation {
  static general = {
    mixed: {
      required: 'GENERAL_FORM_FIELD_IS_REQUIRED_ERROR'
    },
    string: {
      max: 'FORM_VALIDATION_ERROR_MAX_LENGTH_IS_${max}'
    }
  }
}

export default Validation
